import { Component, OnInit, Input } from '@angular/core';
import { IListItemModel } from './models/list-item.model';

@Component({
  selector: 'app-list-item-card',
  templateUrl: './list-item-card.component.html',
  styleUrls: ['./list-item-card.component.scss'],
})
export class ListItemCardComponent implements OnInit {
  @Input() title?: string;
  @Input() listItems?: IListItemModel[];

  constructor() {}

  ngOnInit(): void {}
}
